function getOpt (data) {

 let { dateValue: xData, value: yData } = data

 return {
  backgroundColor: "transparent",
  tooltip: {
   show: true,
   trigger: 'axis',
   backgroundColor: 'rgba(4, 21, 39, 1)',
   borderWidth: 0,
   textStyle: {
    color: '#fff'
   }
  },
  grid: {
   left: "8%",
   top: "15%",
   width: 500,
   height: 120
   // containLabel: true,
  },
  xAxis: {
   type: 'category',
   axisLine: {
    show: true,
    lineStyle: {
     color: '#093E95',
     width: 1
    },
   },
   boundaryGap: true,
   splitLine: {
    show: false
   },
   axisLabel: {
    color: '#D7D7D7',
    fontSize: 14,//bar字体设置
    // interval: 0
   },
   axisTick: {
    show: false,
   },
   data: xData,
  },
  yAxis: {
   name:'万吨',
   nameTextStyle:{
    color:'#fff',
   },
   type: 'value',
   splitLine: {
    show: false,
   },
   axisLine: {
    show: true,
    lineStyle: {
     color: "#093E95"
    }
   },
   axisLabel: {
    color: '#D7D7D7',
    fontSize: 14//bar字体设置
   },
   axisTick: {
    show: false,
   },
  },
  series: [{
   // name: "PM10",
   type: 'line',
   smooth: true,
   showSymbol: false,
   // symbolSize: 0,
   lineStyle: {
    normal: {
     width: 1,
     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(184, 255, 251, 1)'
     },
     {
      offset: 1,
      color: 'rgba(25, 60, 192, 1)'
     }
     ], false)
    }
   },
   itemStyle: {
    normal: {
     // color: "#2EDCB7",
     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(184, 255, 251, 1)'
     },
     {
      offset: 1,
      color: 'rgba(25, 60, 192, 1)'
     }
     ], false)
    }
   },
   data: yData
  }]
 };
}

export default getOpt